class ChartUtility

  @COLORS:
    blue: '#3490dc'
    green: '#1fbba6'
    orange: '#f27935'
    pink: '#f66d9b'
    indigo: '#6574cd'
    purple: '#9561e2'
    white: '#fff'
    grey: '#dae1e7'
    slate: '#5F6E81'

  @maxValue: (array) ->
    Math.max(...@flatten([array]))

  @maxDatasetValue: (context) ->
    @maxValue(context.chart.data.datasets.map((dataset) => dataset.data))

  @flatten: (array) ->
    array.reduce(((acc, el) => if Array.isArray(el) then acc.concat(@flatten(el)) else acc.concat(el)), [])

  @resolveNumber: (obj, dotPath) ->
    return 0 unless obj and dotPath
    tokens = dotPath.split('.')
    value = obj
    (value = value[token] || {}) for token in tokens
    if typeof value is 'object' then 0 else value

export default ChartUtility
